export default {"src":"/_next/static/media/OPAD.e00af819.svg","height":18,"width":18};